import { useTranslation } from "react-i18next";

const WelcomeModal = ({ title, description, cta, skipLabel, onStart, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center">
      <div className="fixed inset-0 bg-black/55" onClick={onClose} />
      <div className="relative bg-white rounded-[24px] shadow-2xl max-w-md w-full mx-4 p-8 text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-[var(--brand,#976DD0)] to-[var(--brand-hover,#7D59B0)] rounded-full flex items-center justify-center mx-auto mb-5">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>

        <h2 className="text-[22px] font-bold text-[#1a1a2e] mb-2">
          {title}
        </h2>

        <p className="text-[14px] text-gray-500 leading-relaxed mb-6">
          {description}
        </p>

        <button
          onClick={onStart}
          className="w-full py-3 bg-gradient-to-r from-[var(--brand,#976DD0)] to-[var(--brand-hover,#7D59B0)] text-white rounded-full font-semibold text-[15px] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
        >
          {cta}
        </button>

        <button
          onClick={onClose}
          className="w-full py-2 mt-2 text-[13px] text-gray-400 hover:text-gray-600 transition"
        >
          {skipLabel}
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
